import SEOHead from '@/components/base/SEOHead';
import SchemaOrg from '@/components/base/SchemaOrg';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedVideos from './components/FeaturedVideos';
import LatestUpdates from './components/LatestUpdates';
import FAQSection from './components/FAQSection';

export default function Home() {
  const canonicalUrl = 'https://www.aiqingdao.com/';

  return (
    <>
      <SEOHead
        title="爱情岛视频-高清在线观看入口 | 爱情岛视频全集高清在线播放"
        description="爱情岛视频高清在线观看入口，提供最新爱情岛视频资源，支持免费流畅观看，无需下载，多线路切换，让您随时随地畅享精彩爱情岛视频内容。爱情岛视频全集、最新资源、高清播放一网打尽。"
        keywords="爱情岛视频,爱情岛视频在线观看,爱情岛视频高清,爱情岛视频免费播放,爱情岛视频全集,爱情岛视频最新资源,爱情岛视频入口"
        canonicalUrl={canonicalUrl}
      />
      <SchemaOrg type="Organization" data={{
        name: '爱情岛视频',
        url: canonicalUrl,
        description: '爱情岛视频高清在线观看入口，提供最新爱情岛视频资源',
      }} />
      <SchemaOrg type="WebSite" data={{
        name: '爱情岛视频',
        url: canonicalUrl,
        potentialAction: {
          '@type': 'SearchAction',
          target: `${canonicalUrl}search?q={search_term_string}`,
          'query-input': 'required name=search_term_string',
        },
      }} />
      <SchemaOrg type="WebPage" data={{
        name: '爱情岛视频 - 首页',
        url: canonicalUrl,
        isPartOf: { '@id': `${canonicalUrl}#website` },
      }} />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <CategoryNav />
          <FeaturedVideos />
          <LatestUpdates />
          <FAQSection />
        </main>
        <Footer />
      </div>
    </>
  );
}